"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidContentException = void 0;
/**
 * This exception is used if the content passed into a function is invalid
 */
class InvalidContentException extends Error {
    /**
     * Optional parameter to include the content of the error
     */
    content;
    /**
     * Constructor
     * @param {string} message the error message
     * @param {object} content the content used for future debugging
     */
    constructor(message, content) {
        super(message);
        this.content = content;
        // If we support a stack trace, capture it
        if ('captureStackTrace' in Error) {
            Error.captureStackTrace(this, this.constructor);
        }
        else {
            console.error(`${this.constructor.name} Does not support captureStackTrace()!`);
        }
    }
    /**
     * Returns the content attribute of the class
     */
    getContent() {
        return this.content;
    }
}
exports.InvalidContentException = InvalidContentException;
